// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Activity__Wrapper_1QG4D","Title":"Activity__Title_5dF_l"};